import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=b5072dda&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=b5072dda&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5072dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5072dda')) {
      api.createRecord('b5072dda', component.options)
    } else {
      api.reload('b5072dda', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=b5072dda&scoped=true", function () {
      api.rerender('b5072dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/snippets/Pagination.vue"
export default component.exports